<template lang="pug">
    section.selector

        .curtain.show(
            ref='curtain'
            )

        .selector__opg

            .opg
                .opg__sections-wrapper(
                    ref='sectionswrapper'
                    )

                    selectorItem(:rootUpdating='rootUpdating')
                    .sections-ui
                        router-link.sections-ui__read(
                            v-html='data.read',
                            :to='`/${curPart}/menu`'
                            :class='{"not-avail": curPart === "thronethieves"}'
                            )
</template>

<script>
import data from '@/assets/data/menu';
import SelectorItem from '@/components/SelectorItem';

export default {
    name: 'Selector',

    components: {
        selectorItem: SelectorItem
    },

    data() {
        return {
            data,
            curPart: this.$route.params.part,
            rootUpdating: false
        };
    },
    watch: {
        $route(to) {
            this.curPart = to.params.part;
        }
    },
    beforeRouteLeave(to, from, next) {
        this.$refs.curtain.classList.add('show');

        setTimeout(() => {
            next();
        }, 600);
    },
    beforeRouteUpdate(to, from, next) {
        this.rootUpdating = true;
        setTimeout(() => {
            next();
            this.rootUpdating = false;
        }, 600);
    },
    mounted() {
        this.$refs.curtain.classList.remove('show');
    }
};
</script>

<style lang="scss" scoped>
@import '../assets/css/vars.scss';

.opg {
    position: absolute;
    width: 100%;
    height: calc(var(--vh) * 100);
    top: 0;
    left: 0;

    &__intro-wrapper,
    &__sections-wrapper {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }

    &__bullets {
        position: absolute;
        width: 100%;
        height: 100vh;
        top: 0;
        left: 0;
        padding-top: 35vh;

        &-bullet {
            position: relative;
            display: block;
            width: 228px;
            margin-bottom: 60px;
            transform: translateX(-100%);
        }
    }

    &__blooddrop {
        position: absolute;
        right: 0;
        top: 0;

        @media (--viewport-tablet) {
            top: unset;
            bottom: calc(0% - 120px);
            transform: rotate(90deg);
        }
    }

    &__text {
        color: white;
        font-family: var(--font-accent);
        font-size: 6.6666rem;
        width: var(--grid-width);
        margin: 0 auto;
        padding-top: 77px;
        line-height: 1.2;
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        //background-image: url(../assets/img/selector/blood.svg);
        background-position: 0 510%;
        background-repeat: repeat-x;
        background-size: 140% 140%;

        @media (--viewport-tablet) {
            font-size: 1.7rem;
            width: 100%;
            padding-left: calc(var(--grid-column-mobile) * 1);
        }
    }
}

.sections-ui {
    position: fixed;
    z-index: 18;
    top: calc(var(--vh) * 95);
    left: 88px;
    color: white;
    text-transform: uppercase;
    pointer-events: all;
    font-style: normal;
    font-weight: bold;
    font-size: 12px;

    &::after {
        content: '▼';
        display: inline-block;
        margin-left: 7px;
    }

    @media (--viewport-tablet) {
        font-size: 11.5px;
        left: var(--grid-column-mobile);
    }

    &.not-avail {
        pointer-events: none;
    }
}

.section {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;

    &__image-wrapper {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }

    &__image-grid-container {
        position: relative;
        width: var(--grid-width);
        height: 100vh;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: center;

        @media (--viewport-laptop) {
            width: 100%;
        }

        @media (--viewport-tablet) {
            width: 100%;
        }
    }

    &__image-container {
        width: calc(var(--grid-column) * 18);
        height: calc((var(--grid-column) * 18) * (439 / 876));
        overflow: hidden;

        @media (--viewport-laptop) {
            width: calc(var(--grid-column-laptop) * 18);
            height: calc((var(--grid-column-laptop) * 18) * (439 / 876));
        }

        @media (--viewport-tablet) {
            width: calc(var(--grid-column-mobile) * 11);
            height: 70vh;
        }
    }

    &__image {
        width: 100%;
        height: auto;
        transform: translateX(100%);

        @media (--viewport-tablet) {
            object-fit: cover;
            height: 100%;
            width: 100%;
        }
    }

    &__text-wrapper {
        position: relative;
        display: block;
        z-index: 20;
        width: var(--grid-width);
        margin: 0 auto;
        padding-top: 77px;
        pointer-events: none;

        @media (--viewport-laptop) {
            width: 100%;
            padding: 77px var(--grid-column-laptop) 0 var(--grid-column-laptop);
        }

        @media (--viewport-tablet) {
            width: auto;
            height: auto;
            padding-top: 0;
            top: 77px;
        }
    }

    &.active {
        .section__text-wrapper {
            pointer-events: all;
        }
    }

    &__text-block {
        position: relative;
        display: block;
        overflow: hidden;
    }

    &__text {
        display: inline-block;
        color: white;
        font-family: var(--font-accent);
        font-size: 6.6666rem;
        line-height: 1.2;
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        //background-image: url(../assets/img/selector/firstbandera-fill.jpg);
        background-size: cover;
        transform: translateY(150%);

        @media (--viewport-tablet) {
            font-size: 1.7rem;
            width: 100%;
            padding-left: calc(var(--grid-column-mobile) * 1);
        }
    }

    &__text--white {
        position: absolute;
        left: 0;
        top: -11px;
        display: inline-block;
        color: white;
        font-family: var(--font-accent);
        font-size: 6.6666rem;
        opacity: 0;

        @media (--viewport-tablet) {
            top: -8%;
            font-size: 1.7rem;
            width: 100%;
            padding-left: calc(var(--grid-column-mobile) * 1);
        }
    }
}

.selector {
    position: absolute;
    z-index: 6;
    width: 100%;
    height: calc(100vh + 1px);
    top: 0;
    left: 0;
    background: black;

    &__opg {
        position: absolute;
        width: 100%;
        height: 100vh;
        top: 0;
        left: 0;
        background: var(--color-black);
        overflow: hidden;
    }
}
// .curtain {
//     position: absolute;
//     z-index: 50;
//     pointer-events: none;
//     background: var(--theme);
//     top: 0;
//     left: 0;
//     width: 100%;
//     height: 100vh;
//     transform: scaleY(0);
//     transition: 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
//     transform-origin: 0 100%;

//     &.show {
//         transform: scaleY(1);
//     }
// }
</style>
